import React from 'react';

import { connect } from "react-redux";

function ExecuteScratchButton(props) {
    return (
        <button className="btn btn-default" style={{ padding: "8px 15px", backgroundColor: "transparent", color: "#65615c" }}
            onClick={(e) => { if (props.onClick !== undefined) { props.onClick(e, props.downloadSource); } }}
            disabled={checkIfButtonShouldBeDisabled(props)}
            title={getButtonTitle(props)}>
            <i className="fas fa-sync-alt"></i>
            <b style={{ marginLeft: 5, ...props.textStyle }}>Ejecutar</b>
        </button>
    );
}

let checkIfButtonShouldBeDisabled = (props) => {
    // console.log(`props.downloadSource.status  ${props.downloadSource.status}`);
    if (props.downloadSource.status === "WAITING_FOR_USER_ACTION" 
        || props.downloadSource.status === "IN_PROCESS" 
        || props.downloadSource.status === "QUEUE_PENDING"
        || props.downloadSource.status === "PAUSED")
        return true;

    if (!props.activeUser.is_staff && !props.activeUser.is_admin)
        return true;

    return false;
}

let getButtonTitle = (props) => {
    if (props.downloadSource.status === "downloading")
        return "Descarga en proceso";

    if (!props.activeUser.is_staff && !props.activeUser.is_admin)
        return "Permisos insuficientes";

    return "Ejecutar descarga";
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser
    };
};

export default connect(mapStateToProps)(ExecuteScratchButton);